import { ServerCrash, RefreshCcw, Home } from "lucide-react";
import { Link } from "react-router-dom";

export default function ServerDown() {
  return (
    <div className="min-h-screen bg-milk flex flex-col items-center justify-center p-4">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-terracotta/10 border border-terracotta/20 text-terracotta mb-4 shadow-sm">
          <ServerCrash className="w-10 h-10" strokeWidth={1.5} />
        </div>
        
        <h1 className="text-4xl font-display font-bold text-cocoa">System Offline</h1>
        
        <p className="text-mahogany">
          We are currently experiencing technical difficulties or undergoing scheduled maintenance. Please try again in a few minutes.
        </p>
        
        <div className="pt-6 flex items-center justify-center gap-3">
          <button 
            onClick={() => window.location.reload()}
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-cocoa text-cream rounded-lg text-sm font-medium hover:bg-mahogany transition-colors shadow-sm"
          >
            <RefreshCcw className="w-4 h-4" />
            Retry Connection
          </button>
          <Link 
            to="/"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-cream border border-border text-cocoa rounded-lg text-sm font-medium hover:bg-brown-100 transition-colors shadow-sm"
          >
            <Home className="w-4 h-4" />
            Dashboard
          </Link>
        </div>
      </div>
      <div className="absolute bottom-8 text-xs text-mahogany/60 italic">
        Sulsa - Woven with love ✿
      </div>
    </div>
  );
}
